import React from "react";
import { Row, Col, Divider } from "antd";
class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { views: 0, time: 0, num: 0 };
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API + `/view/${this.props.person}`)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        this.setState({
          views: this.props.personNumber ? this.props.personNumber : 0,
          time: res.time,
          num: res.num,
        });
      })
      .catch((error) => {
        console.error("Error", error);
      });
  }

  render() {
    const { h1, p, br } = this.props.bannerData;
    return (
      <div className="banner">
        <Row justify="center" align="middle" className="title">
          <Col xxl={6} xl={8} lg={9} md={12} xs={24}>
            <Row>
              <Col span={24}>
                <h1>{h1}</h1>
                <p>
                  {p}
                  <br />
                  {br}
                </p>
              </Col>
            </Row>
          </Col>
          <Col xxl={6} xl={8} lg={9} md={12} xs={24}>
            <Row align="middle" justify="center">
              <Col xs={7} className="text-center">
                <h2>{this.state.views}</h2>
                <p>名學員</p>
              </Col>
              <Divider
                type="vertical"
                style={{ height: "3em", borderColor: "white" }}
              />
              <Col xs={7} className="text-center">
                <h2>{this.state.time}</h2>
                <p>個小時</p>
              </Col>
              <Divider
                type="vertical"
                style={{ height: "3em", borderColor: "white" }}
              />
              <Col xs={7} className="text-center">
                <h2>{this.state.num}</h2>
                <p>個視頻</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Banner;
